import React, { useState, useRef, useEffect } from 'react';
import "./ExportImageButton.css"

const ExportImageButton = ({ 
    groupedMainDeck = {},  // Valor por defecto
    goldCurve = {}, 
  base 
}) => {
  const [isExporting, setIsExporting] = useState(false);
  const canvasRef = useRef(null);

  const exportAllCardsImage = (backgroundImgSrc = null) => {
    setIsExporting(true);
    const canvas = canvasRef.current;
    const ctx = canvas.getContext("2d");

    // Configuración inicial
    const factor = 4;
    const cardWidth = Math.round(710 / factor);
    const cardHeight = Math.round(1016 / factor);
    const margin = 10;
    const marginY = 10;
    const cardsPerRow = 10;
    const headerHeight = 20;
    const columnMargin = 25;
    console.log(groupedMainDeck)
    const cards = Object.values(groupedMainDeck).flat();
    const numRows = Math.ceil(cards.length / cardsPerRow);

    canvas.width = 1920;
    canvas.height = 1080;

    backgroundImgSrc = base;
    let exportTriggered = false;

    // Función de rectángulos redondeados
    function roundRectStroke(
        ctx, x, y, width, height,
        radius = 6,
        strokeStyle = "white",
        fillStyle = "transparent",
        roundedCorners = { tl: true, tr: true, br: true, bl: true }
    ) {
        ctx.beginPath();
        ctx.moveTo(x + (roundedCorners.tl ? radius : 0), y);
        ctx.lineTo(x + width - (roundedCorners.tr ? radius : 0), y);
        if (roundedCorners.tr) ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
        ctx.lineTo(x + width, y + height - (roundedCorners.br ? radius : 0));
        if (roundedCorners.br) ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
        ctx.lineTo(x + (roundedCorners.bl ? radius : 0), y + height);
        if (roundedCorners.bl) ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
        ctx.lineTo(x, y + (roundedCorners.tl ? radius : 0));
        if (roundedCorners.tl) ctx.quadraticCurveTo(x, y, x + radius, y);
        ctx.closePath();

        if (fillStyle !== "transparent") {
            ctx.fillStyle = fillStyle;
            ctx.fill();
        }

        if (strokeStyle !== "transparent") {
            ctx.strokeStyle = strokeStyle;
            ctx.lineWidth = 5;
            ctx.stroke();
        }
    }

    // Dibujar fondo
    const drawBackground = () => {
        return new Promise((resolve) => {
            if (backgroundImgSrc) {
                const bgImg = new Image();
                bgImg.src = backgroundImgSrc;
                bgImg.onload = () => {
                    ctx.drawImage(bgImg, 0, 0, canvas.width, canvas.height);
                    resolve();
                };
                bgImg.onerror = () => {
                    ctx.fillStyle = "white";
                    ctx.fillRect(0, 0, canvas.width, canvas.height);
                    resolve();
                };
            } else {
                ctx.fillStyle = "white";
                ctx.fillRect(0, 0, canvas.width, canvas.height);
                resolve();
            }
        });
    };

    // Ordenar cartas
    cards.sort((a, b) => {
        const typeOrder = {
            "Aliado": 1,
            "Arma": 2,
            "Tótem": 3,
            "Talismán": 4,
            "Oro": 5
        };
        
        if (typeOrder[a.Tipo] !== typeOrder[b.Tipo]) {
            return typeOrder[a.Tipo] - typeOrder[b.Tipo];
        }
        
        if (a.Tipo === "Oro" && b.Tipo === "Oro") {
            if (a.Nombre === "Oro inicial") return -1;
            if (b.Nombre === "Oro inicial") return 1;
        }
        
        return b.Coste - a.Coste;
    });
    // Obtener el prefijo desde la primera carta
    
    const idPrefix = cards?.[0]?.Id?.slice(0, 2) || "es";; // 'es', 'he', etc.
    let color;
    // Dibujar cartas
    const drawCards = () => {
        return new Promise((resolve) => {
            let xPos = columnMargin;
            let yPos = headerHeight;
            let cardCount = 0;

            const processCard = (index) => {
                if (index >= cards.length) {
                    resolve();
                    return;
                }

                const card = cards[index];
                const img = new Image();
                img.crossOrigin = "anonymous";
                img.src = `/images/${card.Ruta}`;

                img.onload = () => {
                    ctx.save();
                    const radius = 9;
                    ctx.beginPath();
                    ctx.moveTo(xPos + radius, yPos);
                    ctx.lineTo(xPos + cardWidth - radius, yPos);
                    ctx.arcTo(xPos + cardWidth, yPos, xPos + cardWidth, yPos + radius, radius);
                    ctx.lineTo(xPos + cardWidth, yPos + cardHeight - radius);
                    ctx.arcTo(xPos + cardWidth, yPos + cardHeight, xPos + cardWidth - radius, yPos + cardHeight, radius);
                    ctx.lineTo(xPos + radius, yPos + cardHeight);
                    ctx.arcTo(xPos, yPos + cardHeight, xPos, yPos + cardHeight - radius, radius);
                    ctx.lineTo(xPos, yPos + radius);
                    ctx.arcTo(xPos, yPos, xPos + radius, yPos, radius);
                    ctx.closePath();
                    ctx.clip();

                    ctx.drawImage(img, xPos, yPos, cardWidth, cardHeight);
                    ctx.restore();

                    //ctx.fillStyle = "rgba(51, 102, 153, 1)";
                    // Coordenadas del rectángulo
                    const rectWidth = 35;
                    const rectHeight = 35;
                    const rectX = xPos + cardWidth / 2 - rectWidth / 2;
                    const rectY = yPos + cardHeight - rectHeight - 60;
                    const rectRadius = 6; // Puedes ajustar el radio a tu gusto

                    // Dibujar rectángulo con bordes redondeados
                    ctx.beginPath();
                    ctx.moveTo(rectX + rectRadius, rectY);
                    ctx.lineTo(rectX + rectWidth - rectRadius, rectY);
                    ctx.arcTo(rectX + rectWidth, rectY, rectX + rectWidth, rectY + rectRadius, rectRadius);
                    ctx.lineTo(rectX + rectWidth, rectY + rectHeight - rectRadius);
                    ctx.arcTo(rectX + rectWidth, rectY + rectHeight, rectX + rectWidth - rectRadius, rectY + rectHeight, rectRadius);
                    ctx.lineTo(rectX + rectRadius, rectY + rectHeight);
                    ctx.arcTo(rectX, rectY + rectHeight, rectX, rectY + rectHeight - rectRadius, rectRadius);
                    ctx.lineTo(rectX, rectY + rectRadius);
                    ctx.arcTo(rectX, rectY, rectX + rectRadius, rectY, rectRadius);
                    ctx.closePath();
                    // agregar switch
                    switch (idPrefix) {
                        case "es":
                            color = "rgb(116, 38, 141)"; // color 1
                            break;
                        case "he":
                            color = "rgb(194, 147, 96)"; // color 2
                            break;
                        case "hd":
                            color = "rgb(1, 145, 154)"; // color 3
                            break;
                        case "ra":
                            color = "rgb(176, 60, 59)"; // color 4
                            break;
                        default:
                            color = "rgba(51, 102, 153, 1)"; // color por defecto
                            break;
                    }
                    
                    // Aplicar sombra antes de rellenar el rectángulo
                    ctx.shadowColor = "rgba(0, 0, 0, 0.6)";
                    ctx.shadowBlur = 6;
                    ctx.shadowOffsetX = 2;
                    ctx.shadowOffsetY = 2;

                    ctx.fillStyle = color;
                    ctx.fill();

                    // Restablecer sombra antes de dibujar texto
                    ctx.shadowColor = "transparent";
                    ctx.shadowBlur = 0;
                    ctx.shadowOffsetX = 0;
                    ctx.shadowOffsetY = 0;

                    // Dibujar texto
                    ctx.fillStyle = "white";
                    ctx.textAlign = "center";
                    ctx.font = "bold 22px Poppins";
                    ctx.fillText(`${card.quantity}`, xPos + cardWidth / 2, yPos + cardHeight - 70);

                    cardCount++;
                    if (cardCount % cardsPerRow === 0) {
                        yPos += cardHeight + marginY;
                        xPos = columnMargin;
                    } else {
                        xPos += cardWidth + margin;
                    }

                    processCard(index + 1);
                };

                img.onerror = () => {
                    cardCount++;
                    processCard(index + 1);
                };
            };

            processCard(0);
        });
    };

    // Dibujar resumen
    const drawSummary = () => {
        return new Promise((resolve) => {
            ctx.font = "bold 22px Poppins";
            ctx.textAlign = "center";
            ctx.fillStyle = "white";
            ctx.shadowColor = "rgba(0, 0, 0, 1)";
            ctx.shadowBlur = 3;
            ctx.shadowOffsetX = 2;
            ctx.shadowOffsetY = 2;

            let startY = 325;
            const typeEntries = Object.entries(groupedMainDeck);

            // Curva de Oro
            ctx.shadowColor = "transparent";
            ctx.shadowBlur = 0;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            const fixedCosts = ["0", "1", "2", "3", "4", "5", "6"];
            const xReview = 1050;
            const goldStartY = startY + 525;
            ctx.fillStyle = "#5E2F46";
            ctx.fillText("Curva de Oro", xReview+140, goldStartY);
            ctx.textAlign = "left";
            const maxHeight = 150;
            const valueMargin = 25;
            const barWidth = 33;
            const spacing = 9;
            const barRadius = 12;
            const goldValues = fixedCosts.map(cost => goldCurve[cost] || 0);
            const maxCount = Math.max(...goldValues, 1);

            fixedCosts.forEach((cost, idx) => {
                const count = goldCurve[cost] || 0;
                const x = xReview + idx * (barWidth + spacing);
                const yTop = goldStartY + 20;
                const yBottom = yTop + maxHeight;

                ctx.shadowColor = "#00000033";
                ctx.shadowBlur = 6;
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 3;
                roundRectStroke(ctx, x, yTop, barWidth, maxHeight, barRadius, "#D3BCC0", "transparent");
                ctx.shadowColor = "transparent";
                ctx.shadowBlur = 0;
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 0;
                roundRectStroke(ctx, x, yTop, barWidth, maxHeight, barRadius, "transparent", "#F0E5CF");

                const adjustedMaxHeight = maxHeight - valueMargin;
                const barHeight = count > 0 ? (count / maxCount) * adjustedMaxHeight : 9;
                const y = yBottom - barHeight;

                if (count > 0) {
                    roundRectStroke(ctx, x, y, barWidth, barHeight, 6, "transparent", "#B2658B", {
                        tl: false, tr: false, br: true, bl: true
                    });
                }
                roundRectStroke(ctx, x, yTop, barWidth, maxHeight, barRadius, "#D3BCC0", "transparent");   
                
                const labelY = y - 5;
                ctx.fillStyle = "#5E2F46";
                ctx.font = "bold 14px Poppins";
                ctx.textAlign = "center";
                ctx.fillText(`${count}`, x + barWidth / 2, labelY);

                const costLabel = cost >= 6 ? "6+" : `${cost}`;
                const labelFont = "14px Poppins";
                ctx.font = labelFont;
                ctx.textAlign = "center";
                const labelWidth = 30;
                const labelHeight = 30;
                const labelX = x + barWidth / 2 - labelWidth / 2;
                const labelYy = yBottom + 10;
                ctx.shadowColor = "#00000033";
                ctx.shadowBlur = 6;
                ctx.shadowOffsetX = 0;
                ctx.shadowOffsetY = 3;
                roundRectStroke(ctx, labelX, labelYy, labelWidth, labelHeight, 10, "transparent", "#5E2F46");
                ctx.fillStyle = "white";
                if (costLabel )
                ctx.fillText(costLabel, x + barWidth / 2, labelYy + labelHeight / 2 + 4);
            });

            // Distribución por tipo
            const orderedTypes = ["Aliado", "Arma", "Tótem", "Talismán", "Oro"];
            const typeImages = {
                "Aliado": "/images/aliado.png",
                "Arma": "/images/arma.png",
                "Tótem": "/images/totem.png",
                "Talismán": "/images/talisman.png",
                "Oro": "/images/oro.png"
            };
            const entryWidth = 90;
            const entryIMG = 65;
            const entrySpacing = 10;
            const radius = 10;
            ctx.font = "bold 22px Poppins";
            ctx.textAlign = "center";
            ctx.fillStyle = "#5E2F46";
            ctx.shadowColor = "#00000033";
            ctx.shadowBlur = 0;
            ctx.shadowOffsetX = 0;
            ctx.shadowOffsetY = 0;
            ctx.fillText("Distribución del Mazo", 1630, goldStartY+ 60);
            
            const loadImages = orderedTypes.map((type) => {
                return new Promise((resolveImg) => {
                    const img = new Image();
                    img.src = typeImages[type];
                    img.onload = () => {
                        const group = groupedMainDeck[type] || [];
                        const cantidad = group.reduce((acc, c) => acc + c.quantity, 0);
                        const x = 1400 + orderedTypes.indexOf(type) * (entryWidth + entrySpacing);
                        const y = goldStartY+80;
                        ctx.shadowColor = "#00000033";
                        ctx.shadowBlur = 6;
                        ctx.shadowOffsetX = 0;
                        ctx.shadowOffsetY = 5;
                        roundRectStroke(ctx, x, y, entryWidth, entryWidth, radius, "transparent", "#B2658B");
                        ctx.drawImage(img, x, y+8, entryIMG, entryIMG);
                        ctx.shadowColor = "#00000033";
                        ctx.shadowBlur = 0;
                        ctx.shadowOffsetX = 0;
                        ctx.shadowOffsetY = 0;
                        ctx.fillStyle = "white";
                        ctx.font = "14px Poppins";
                        ctx.textAlign = "center";
                        ctx.fillText(`${type}`, x + 45, y + entryWidth-4);
                        ctx.font = "bold 22px Poppins";
                        ctx.fillText(`${cantidad}`, x + 72, y + entryWidth-40);
                        resolveImg();
                    };
                    img.onerror = resolveImg;
                });
            });

            Promise.all(loadImages).then(resolve);
        });
    };

    // Exportar imagen
    const exportImage = () => {
        if (exportTriggered) return;
        exportTriggered = true;

        const now = new Date();
        const dateStr = now.toLocaleDateString('en-CA').replaceAll('-', ''); // YYYYMMDD
        const randomNum = Math.floor(Math.random() * 10000); // número aleatorio de 0 a 9999
        const fileName = `elmeta_${dateStr}_${randomNum}.png`;

        const link = document.createElement('a');
        link.download = fileName;
        link.href = canvas.toDataURL('image/png');
        link.click();

        setIsExporting(false);
        };
    // Ejecución principal
    const executeExport = async () => {
        await drawBackground();
        await drawCards();
        await drawSummary();
        exportImage();
    };

    executeExport();
  };

return (
  <>
    <canvas ref={canvasRef} style={{ display: 'none' }} />
    <button
      onClick={exportAllCardsImage}
      className="btn-export"
      disabled={isExporting}
    >
      {isExporting ? (
        <i className="fa-solid fa-spinner fa-spin"></i> // Ícono girando
      ) : (
        <i className="fa-solid fa-print"></i> // Ícono de impresora
      )}
    </button>
  </>
);
};

export default ExportImageButton;